<template>
    <div>
        <h1></h1>
        사용자정보
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
                label="Name"
                label-for="name-input"
                invalid-feedback="Name is required"
                :state="nameState"
                >
                <b-form-input
                    id="name-input"
                    v-model="name"
                    :state="nameState"
                    required
                ></b-form-input>
            </b-form-group>
        </form>
    </div>
    
</template>
<script>

export default {
    data() {
        return {
            name : '',
            nameState : null
        }
    },
    methods: {
        handleSubmit() {
            this.$nextTick(() => {
                this.$bvModal.hide('popupModal');
            })
        }
    },
    mounted: function(){
    }
}
</script>